export default __webpack_public_path__ + "static/media/fuze_upper.35f46f21.jpg";